/* eslint-disable */
/* eslint-disable no-extra-parens,global-require */
import React, { useState, useEffect, Fragment, useRef } from 'react';
import { Link, useLocation, withRouter } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import NotificationsIcon from '@mui/icons-material/Notifications';

import {
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  MINI_DRAWER,
} from 'modules/cbre-flow-Common/constants/ActionTypes';
import {
  switchLanguage,
  toggleCollapsedNav,
  updateLocaleSelection,
} from 'modules/cbre-flow-Common/actions/Setting';
import IntlMessages from 'util/IntlMessages';
import Avatar from '@mui/material/Avatar';
import UserInfoPopup from 'components/UserInfo/UserInfoPopup';
import Drawer from '@mui/material/Drawer';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { WHITE } from 'modules/cbre-flow-Common/constants/ThemeColors';
import Badge from '@mui/material/Badge';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {
  getLogOutUrl,
  updateUserLocaleUrl,
} from 'modules/cbre-flow-Common/selectors';
import SideBarContent from '../../../SideBar/SideBarContent';
import {
  defaultLang,
  languageData as language,
} from 'components/LanguageSwitcher/data';
import { Track } from 'containers/Services/AnalyticsProvider';
import { Button, ButtonBase, Popover } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import AppsIcon from '@mui/icons-material/Apps';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { ExternalReports, HelpInfoPopup, LocationSelection } from 'modules/cbre-flow-site-location';
import { getUserAccess } from 'modules/cbre-flow-api-ducks/selectors';

// eslint-disable-next-line complexity
const Index = (props) => {
  const { location, hideMenu, logOutUrl, isFusion } = props;
  const dispatch = useDispatch();
  const [languageData, setLanguageData] = useState(language);
  const [prevUrl, setPrevUrl] = useState(null);
  const [isLocationDrawerOpen, setIsLocationDrawerOpen] = useState(false);
  const { navCollapsed } = useSelector(({ common }) => common);
  const { userDisplayName, userEmailId, authUser } = useSelector(
    ({ auth }) => auth,
  );
  const userLocale = localStorage.getItem('locale');
  const localeUrl = useSelector(updateUserLocaleUrl);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [appsAnchorEl, setAppsAnchorEl] = React.useState(null);
  const [locationAnchorEl, setLocationAnchorEl] = React.useState(null);
  const [userInfoAnchorEl, setUserInfoAnchorEl] = React.useState(null);
  const showLanguageSelection = true; // location.pathname.indexOf('cpp') === 1;
  const { drawerType, locale, themeColor } = useSelector(
    ({ settings }) => settings,
  );
  
  const { site } = useSelector(getUserAccess);
  const [helpInfo, setHelpInfo] = useState(false);
  const [reportsInfo, setReportsInfo] = useState(false);
  const [locationInfo, setLocationInfo] = useState(false);

  const isDashboard = location.pathname === '/dashboard';

  const toggleDrawer = () => {
    setIsLocationDrawerOpen(!isLocationDrawerOpen);
  };

  useEffect(() => {
    const currentPath = location.pathname.toLowerCase();
    if (currentPath.includes('programmanagement')) {
      const languageData = [];
      languageData.push(language[0]);
      setLanguageData(languageData);
    }
  }, [location.pathname]);

  const changeLanguage = (selectedLang) => {
    dispatch(switchLanguage(selectedLang));
    document.dispatchEvent(
      new CustomEvent('languageChange', { detail: selectedLang }),
    );
  };


  const onUserInfoSelect = (event) => {
    setUserInfoAnchorEl(event.currentTarget);
  };
  const onUserInfoClose = () => {
    setUserInfoAnchorEl(null);
  };
  const onHelpInfoSelect = () => {
    setHelpInfo(!helpInfo);
  };
  const onToggleCollapsedNav = () => {
    const val = !navCollapsed;
    dispatch(toggleCollapsedNav(val));
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAppsClick = (event) => {
    setAppsAnchorEl(event.currentTarget);
  };

  const handleAppsClose = () => {
    setAppsAnchorEl(null);
  };

  const handleLocationClick = (event) => {
    // setLocationAnchorEl(event.currentTarget);
    toggleDrawer();
  };

  const sideDrawerStyle = drawerType.includes(FIXED_DRAWER)
    ? 'd-xl-flex'
    : drawerType.includes(COLLAPSED_DRAWER)
      ? ''
      : 'd-flex';

  let type = 'permanent';
  if (
    drawerType.includes(COLLAPSED_DRAWER) ||
    (drawerType.includes(FIXED_DRAWER) && window.innerWidth < 1200)
  ) {
    type = 'temporary';
  }
  const drawerStyle = drawerType.includes(FIXED_DRAWER)
    ? 'd-block d-xl-none'
    : drawerType.includes(COLLAPSED_DRAWER)
      ? 'd-block'
      : 'd-none';
  return (
    <AppBar className="app-main-header" elevation={0}>
      {!hideMenu &&
      !(
        drawerType.includes(MINI_DRAWER) ||
        (drawerType.includes(FIXED_DRAWER) && window.innerWidth >= 1200)
      ) ? (
        <div className={`app-sidebar d-none ${sideDrawerStyle}`}>
          <Drawer
            className="app-sidebar-content"
            variant={type}
            open={type.includes('temporary') ? navCollapsed : true}
            onClose={onToggleCollapsedNav}
            classes={{
              paper: 'side-nav top-49',
            }}
          >
            {/* <UserInfo/> */}
            <SideBarContent />
          </Drawer>
        </div>
      ) : (
        ''
      )}
      <Toolbar
        disableGutters={false}
        className={`app-toolbar p-3 ${
          location.pathname === '/dashboard'
            ? 'app-toolbar-dashboard'
            : 'app-toolbar-other'
        }`}
      >
        {!hideMenu && (
          <Fragment>
            <IconButton
              className={`pjm-menu-icon mr-2 ${drawerStyle}`}
              aria-label="Menu"
              onClick={onToggleCollapsedNav}
            >
              <span>
                <i className="zmdi zmdi-menu hamburger-menu-icon"></i>
              </span>
            </IconButton>
          </Fragment>
        )}
        {!hideMenu && (
          <Link
            className={` app-logo  mr-2 d-none d-sm-block ${!props.hideMenu ? '' : 'hide-menu'}`}
            to="/dashboard"
          >            
            <IntlMessages id="header.pjmTechnologyPortal" />
            <span className="left-spaced">
              <IntlMessages id="header.fromCbre" />
            </span>
          </Link>
        )}
        {hideMenu && (
          <span
            className={` app-logo  mr-2 d-none d-sm-block ${!props.hideMenu ? '' : 'hide-menu'}`}
            to="/"
          >
            <IntlMessages id="header.pjmTechnologyPortal" />
            <span className="left-spaced">
              <IntlMessages id="header.fromCbre" />
            </span>
          </span>
        )}

        <ul className="header-notifications ml-auto">
          
          {/* {location.pathname.startsWith('/admin/users') && (
            <li className="list-inline-item user-nav help-list-icon cursor-pointer">
              <ButtonBase
                variant="contained"
                onClick={handleLocationClick}
                focusRipple
              >
                <div className="site-location-header-button">
                  <LocationOnOutlinedIcon
                    className={isDashboard ? 'green-c-dark' : 'white-c'}
                    style={{ color: '#FFFFFF99', fontSize: 23 }}
                  />
                  <h1>{site?.siteName} {site?.description}</h1>
                  <ArrowDropDownIcon style={{ color: '#80BBAD' }} />
                </div>
              </ButtonBase>
              <Drawer anchor="right" open={isLocationDrawerOpen} onClose={toggleDrawer} style={{ zIndex: 1250, width: '520px' }} PaperProps={{ style: { width: '520px', padding: 16 } }}>
                <Typography variant="h6" className="title d-flex mb-4">
                   Change site
                </Typography>
                <LocationSelection closeSiteSelection={toggleDrawer} />
              </Drawer>
            </li>
          )} */}
          <li className="list-inline-item user-nav help-list-icon cursor-pointer">
            <IconButton variant="contained" onClick={handleClick} focusRipple style={{ color: "#fff", width: 36, height: 36 }}>
              <HelpIcon
                className={isDashboard ? 'green-c-dark' : 'white-c'}
                style={{ color: '#FFFFFF99', fontSize: 21 }}
              />
            </IconButton>
            <Popover
              id={'helpInfo'}
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <HelpInfoPopup onClose={handleClose} />
            </Popover>
          </li>
          {authUser && authUser !== null && (
            <li className="list-inline-item user-nav">
              <IconButton
                className="icon-btn"
                focusRipple
                style={{ color: "#fff", width: 36, height: 36 }}
                onClick={onUserInfoSelect}
              >
                <Badge
                  badgeContent="1"
                  color="error"
                  overlap="circular"
                  invisible={true}
                >
                  <Avatar
                    style={{
                      
                      color: '#003F2D',
                      fontSize: 12,
                      background: '#FFFFFF99',
                    }}
                    sx={{ width: 20, height: 20 }}
                    className='d-flex align-items-center'
                  >
                    {`${userDisplayName?.split(' ')[0][0]}${userDisplayName?.split(' ')[1][0]}`}
                  </Avatar>
                </Badge>
              </IconButton>
              <Popover
                id={'userInfo'}
                open={Boolean(userInfoAnchorEl)}
                anchorEl={userInfoAnchorEl}
                onClose={onUserInfoClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                PaperProps={{
                  sx: {
                    mt: 1,
                    overflow: 'visible',
                    '&::before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: '#ecf5f2',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}
              >
                <UserInfoPopup
                  logOutUrl={logOutUrl}
                  isFusion={isFusion}
                  userDisplayName={userDisplayName}
                  userEmailId={userEmailId}
                />
              </Popover>
            </li>
          )}
          <li className="list-inline-item user-nav help-list-icon cursor-pointer">
            <IconButton 
              variant="contained"
              onClick={handleAppsClick}
              focusRipple
              style={{ color: "#fff", width: 36, height: 36 }}
            >
              <AppsIcon
                className={isDashboard ? 'green-c-dark' : 'white-c'}
                style={{ color: '#FFFFFF99' }}
                fontSize="medium"
              />
            </IconButton>
            <Popover
              id={'helpInfo'}
              open={Boolean(appsAnchorEl)}
              anchorEl={appsAnchorEl}
              onClose={handleAppsClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <ExternalReports />
            </Popover>
          </li>
        </ul>
      </Toolbar>
    </AppBar>
  );
};
Index.propTypes = {
  hideMenu: PropTypes.bool,
  isFusion: PropTypes.bool,
  logOutUrl: PropTypes.string,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};
const mapStateToProps = (state) => ({
  logOutUrl: getLogOutUrl(state),
  fusionProjectsListUrl: '',
});
export default connect(mapStateToProps)(withRouter(Index));
